module.exports = __webpack_public_path__ + "img/loading.f2d128bd.gif";